import { Stack } from "@mui/material";
import { CampaignGaps } from "../../types/apiTypes";
import { ProductMissingBlock } from "./ProductMissingBlock";

type Props = { role_gaps: CampaignGaps; title_gaps: CampaignGaps };

export const GapAnalysisBlock = ({ role_gaps, title_gaps }: Props) => {
  return (
    <Stack
      sx={{
        border: "1px solid #D9D9D9",
        padding: "16px",
        borderRadius: "8px",
        gap: "16px",
      }}
    >
      <ProductMissingBlock
        label={"Missing Roles:"}
        list={role_gaps.high_impact}
      />
      <ProductMissingBlock
        label={"Missing Job functions:"}
        list={title_gaps.high_impact}
      />
    </Stack>
  );
};
